var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadBox"},[_c('Breadcrumb',{attrs:{"separator":"<b class='breadcrumb-separator'>></b>"}},_vm._l((_vm.levelList),function(item,index){return _c('BreadcrumbItem',{key:index,attrs:{"to":item.meta.path}},[_vm._v(_vm._s(item.name))])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5386f290","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bread/ItBread.vue
// module id = null
// module chunks = 